module.exports = __webpack_public_path__ + "img/folk_art.abc155c0.jpg";